import { render, staticRenderFns } from "./familyInvest.vue?vue&type=template&id=4979ab5e&"
import script from "./familyInvest.vue?vue&type=script&lang=js&"
export * from "./familyInvest.vue?vue&type=script&lang=js&"
import style0 from "./familyInvest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports